import React, { useState } from 'react';
import './paymentForm.css';

export default function PaymentForm({
  invoice_number,
  document_type = 'invoice',
  payment_type,
  payment_number,
  payment_date,
  payment_method,
  onConfirm,
  onClose,
}) {
  const [paymentNumber, setPaymentNumber] = useState(payment_number);
  const [paymentDate, setPaymentDate] = useState(payment_date);
  const [paymentMethod, setPaymentMethod] = useState(
    document_type === 'credit' ? '' : payment_method || payment_type
  );

  const dataHasChanged = () => {
    return (
      paymentNumber !== payment_number ||
      paymentDate !== payment_date ||
      paymentMethod !== payment_method
    );
  };

  const handleChangePaymentNumber = e => {
    let filteredValue = e.target.value || '';
    filteredValue = filteredValue.replace(
      /[^a-zA-Z0-9.,!? áàâäãåçéèêëíìîïñóòôöõøúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕØÚÙÛÜÝ @ \n]/g,
      ''
    );
    setPaymentNumber(filteredValue);
  };

  const handleChangePaymentDate = e => {
    setPaymentDate(e.target.value);
  };

  const handleChangePaymentMethod = e => {
    setPaymentMethod(e.target.value);
  };

  const handleConfirmPayment = () => {
    onConfirm(invoice_number, paymentNumber, paymentDate, paymentMethod, dataHasChanged());
  };

  const isCredit = document_type === 'credit';
  const title = isCredit
    ? `Utilisation avoir n° ${invoice_number}`
    : `Règlement facture n° ${invoice_number}`;
  const numberLabel = isCredit ? 'Informations avoir :' : 'Numéro de règlement :';
  const dateLabel = isCredit ? "Date d'utilisation :" : 'Date de règlement :';

  return (
    <div className="overlay">
      <div className="payment-form-content">
        <span className="overlay-close" onClick={onClose}>
          &times;
        </span>
        <h3>{title}</h3>

        <div className="payment-form-inputs">
          <div className="horizontal-input-group">
            <label>{numberLabel}</label>
            <input
              type="text"
              name="payment_number"
              value={paymentNumber}
              onChange={handleChangePaymentNumber}
            />
          </div>
          <div className="horizontal-input-group">
            <label>{dateLabel}</label>
            <input
              type="date"
              name="payment_date"
              value={paymentDate}
              onChange={handleChangePaymentDate}
            />
          </div>
          {!isCredit && (
            <div className="horizontal-input-group">
              <label>Moyen de règlement :</label>
              <select
                type="text"
                name="payment_method"
                value={paymentMethod}
                onChange={handleChangePaymentMethod}
              >
                <option>CHEQUE</option>
                <option>VIREMENT</option>
              </select>
            </div>
          )}
        </div>

        <button type="button" onClick={handleConfirmPayment}>
          Valider
        </button>
      </div>
    </div>
  );
}
